import React from 'react';
import { useParams } from 'react-router-dom';
import SearchDetail from '../../components/search/SearchDetail/SearchDetail';
import Header from '../../components/layout/Header/Header';

const SearchDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  return (
    <>
      <Header />
      <div className="flex justify-center w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[950px] w-full">
          <SearchDetail />
        </div>
      </div>
    </>
  );
};

export default SearchDetails; 